// globals.js
export let authToken = ''; // Declare the global variable

// This file contains the login api
export const sendOtpUrl = `http://stg.panditjee.com:8080/api/otp/sendOtp`;
export const validateOtp = `http://stg.panditjee.com:8080/api/otp/validateOtp`;

// This file contains the Navbar APIs
export const getAdminProfile = 'http://stg.panditjee.com:8080/api/getAllUsersProfiles';

// This file contains the user management APIs
export const getuser = "http://stg.panditjee.com:8080/api/getAllUsersProfiles";
export const adduser= "http://stg.panditjee.com:8080/api/userProfile/add";
export const deluser= "http://stg.panditjee.com:8080/api/userProfile/delete";
export const getuserbyid = (id) => `http://stg.panditjee.com:8080/api/userProfile/${id}`;
export const updateuser = (userId) => `http://stg.panditjee.com:8080/api/updateUserProfile/${userId}`;

// This file contains the purohit APIs
export const addPurohit = "http://stg.panditjee.com:8080/api/addUser";
export const purohitUrl = 'http://stg.panditjee.com:8080/api/purohitsList';
export const getPurohitById = (id) => `http://stg.panditjee.com:8080/api/userProfile/${id}`;
export const updatePurohit = (purohitId) => `http://stg.panditjee.com:8080/api/updateUserProfile/${purohitId}`;

// This file contains the Category Management APIs
export const getCatManData = 'http://stg.panditjee.com:8080/api/getPoojaCategoryFEData';
export const addPujaCategory = 'http://stg.panditjee.com:8080/api/addPoojaCategoryByAdmin';
export const addPujaSubCategory = 'http://stg.panditjee.com:8080/api/addPoojaSubCategoryByAdmin';
export const updatePujaCategory = 'http://stg.panditjee.com:8080/api/updatePoojaCategoryByAdmin';
export const deletePujaCategory = (id) => `http://stg.panditjee.com:8080/api/deletePoojaCategoryByAdmin/${id}`;
export const updatePujaSubCategory = 'http://stg.panditjee.com:8080/api/updatePoojaSubCategoryByAdmin';
export const deletePujaSubCategory = (id) => `http://stg.panditjee.com:8080/api/deletePoojaSubCategoryByAdmin/${id}`;

// This file contains the aarti management APIs
export const getAartiData = 'http://stg.panditjee.com:8080/api/aartiDetails/aarti/getFEData';
export const createAartiByAdmin = 'http://stg.panditjee.com:8080/api/aartiDetails/aarti/createAartiByAdmin';
export const updateAartiByAdmin = 'http://stg.panditjee.com:8080/api/aartiDetails/aarti/update';
export const deleteAartiByAdmin = (id) => `http://stg.panditjee.com:8080/api/aartiDetails/aarti/delete/${id}`;
export const createAartiContentByAdmin = 'http://stg.panditjee.com:8080/api/aartiDetails/aarti/createAartiContentByAdmin';
export const updateAartiContentByAdmin = 'http://stg.panditjee.com:8080/api/aartiDetails/aarti/content/update';
export const deleteAartiContentByAdmin = (id) => `http://stg.panditjee.com:8080/api/aartiDetails/aarti/content/delete/${id}`;
export const importAartiCsv = 'http://stg.panditjee.com:8080/api/aartiDetails/import/csv/combined';

// This file contains the mantra management APIs
export const getMantraData = 'http://stg.panditjee.com:8080/api/mantraDetails/all';
export const createMantra = 'http://stg.panditjee.com:8080/api/mantraDetails/create';

// This file contains the Article management APIs
export const getArticleDetails = 'http://stg.panditjee.com:8080/api/articleDetails/all';
export const createArticle = 'http://stg.panditjee.com:8008/api/articleDetails/articles/create';
export const updateArticle = 'http://stg.panditjee.com:8080/api/articleDetails/articles/update';
export const deleteArticle = (id) => `/api/articleDetails/article/deleteArticleByAdmin/${id}`;
export const updateArticleContent = 'http://stg.panditjee.com:8080/api/articleDetails/articles/update';
export const deleteArticleContent = (id) => `http://stg.panditjee.com:8080/api/articleDetails/article/deleteArticleContentByAdmin/${id}`;

// This file contains the Youtube management APIs
export const getYoutubeVideos = 'http://stg.panditjee.com:8080/api/youtubeVideos/all';
export const createYoutubeVideo = 'http://stg.panditjee.com:8080/api/youtubeVideos/videos/create';
// Not create other API like update or delete.

// This file contains the stream Video management APIs
export const updateStreamVideo = 'http://stg.panditjee.com:8080/api/videos/update';

// This file contains the Event management APIs
export const getAllEvents = 'http://stg.panditjee.com:8080/api/events/all';
export const createEvents = 'http://stg.panditjee.com:8080/api/events/event/create';
export const updateEvent = 'http://stg.panditjee.com:8080/api/eventDetails/update';
export const deleteEvent = (id) => `http://stg.panditjee.com:8080/api/eventDetails/delete/${id}`;
export const importEvents = 'http://stg.panditjee.com:8080/api/events/import';

// This file contains the Dashboard APIs
export const getAllUsersProfiles = 'http://stg.panditjee.com:8080/api/getAllUsersProfiles';
export const getAllPurohitProfileList = 'http://stg.panditjee.com:8080/api/purohitsList';
export const getPoojaCategoryFEData = 'http://stg.panditjee.com:8080/api/getPoojaCategoryFEData';
export const getAartiDetails = 'http://stg.panditjee.com:8080/api/aartiDetails/aarti/getFEData';
export const getMantraDetails = 'http://stg.panditjee.com:8080/api/mantraDetails/all';
export const getArticleDetail = 'http://stg.panditjee.com:8080/api/articleDetails/all';
export const getYoutubeVideosData = 'http://stg.panditjee.com:8080/api/youtubeVideos/all';
export const getEvents = 'http://stg.panditjee.com:8080/api/events/all';

// This file contains the Notification APIs
export const sendToUser = 'http://stg.panditjee.com:8080/api/notifications/sendToUser';
export const sendToAllUsers = 'http://stg.panditjee.com:8080/api/notifications/sendToAllUsers';

// This file contains the Payment Management APIs
export const getPaymentDetails = 'http://stg.panditjee.com:8080/api/payments/getAll';

// This file contains the Product Management APIs
export const getProducts = (categoryId) => `http://stg.panditjee.com:8080/api/products/${categoryId}`;
export const addProductCategory = 'http://stg.panditjee.com:8080/api/addProductCategory';
export const updateProductCategory = 'http://stg.panditjee.com:8080/api/updateProductCategory';
export const deleteProductCategory = (id) => `http://stg.panditjee.com:8080/api/deleteProductCategory/${id}`;
export const addProductSubCategory = 'http://stg.panditjee.com:8080/api/addProductSubCategory';
export const updateProductSubCategory = 'http://stg.panditjee.com:8080/api/updateProductSubCategory';
export const deleteProductSubCategory = (id) => `http://stg.panditjee.com:8080/api/deleteProductSubCategory/${id}`;

// Temple Management APIs
export const getAllTemples = 'http://stg.panditjee.com:8080/api/temples/all';
export const createTemple = 'http://stg.panditjee.com:8080/api/temples/create';
export const updateTemple = (id) => `http://stg.panditjee.com:8080/api/temples/update/temple/${id}`;
export const deleteTemple = (id) => `http://stg.panditjee.com:8080/api/temples/delete/${id}`;
export const importTempleCSV = 'http://stg.panditjee.com:8080/api/temples/import/csv';
export const getAllPurohitProfiles = 'http://stg.panditjee.com:8080/api/purohitsList';


// Content Library APIs
export const getAllContentLibrary =
  'http://stg.panditjee.com:8080/api/content-library/all';

export const addContentLibrary =
  'http://stg.panditjee.com:8080/api/content-library/add';

export const updateContentLibrary =
  'http://stg.panditjee.com:8080/api/content-library/update';

export const toggleContentLibraryStatus =
  'http://stg.panditjee.com:8080/api/content-library/toggleStatus';